module.exports = __webpack_public_path__ + "static/media/20240530075733_IMG_7387-min.590154a6.JPG";